import { ThermometerIcon } from './ThermometerIcon';

/**
 * author: Austin Andrews
 * id F41863ED-B66A-4FF4-B436-0876C8D3665B
 * name thermometer
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/thermometer.svg
 * tags
 * - Weather 
 * - Home Automation 
 * - Automotive 
 */
export const TemperatureIcon = ThermometerIcon;
export default TemperatureIcon